import { render, staticRenderFns } from "./NewSiteRegisterForm.vue?vue&type=template&id=37c6e2e0&"
import script from "./NewSiteRegisterForm.vue?vue&type=script&lang=js&"
export * from "./NewSiteRegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports